import React from 'react'

const AnalyticsDashboard = () => {
  return (
    <div>AnalyticsDashboard</div>
  )
}

export default AnalyticsDashboard